const data = {
  locations: [
    {
      state: "WA",
      waitTimeDays: 365,
      postalCode: "98230",
      countryCode: "US",
      id: "5020",
      city: "BLAINE",
      shortName: "Blaine NEXUS and FAST Enrollment Center ",
      coordinates: [48.953455, -122.705013],
      urlString: "blaine-nexus-and-fast-enrollment-center",
      name: "Blaine NEXUS And FAST Enrollment Center ",
    },
    {
      urlString: "buffalo-ft-erie-enrollment-center",
      shortName: "Buffalo-Ft. Erie Enrollment Center",
      postalCode: "L2A6G6",
      waitTimeDays: 365,
      state: "ON",
      name: "Buffalo-Ft. Erie Enrollment Center",
      id: "5022",
      city: "FORT ERIE",
      coordinates: [42.906043, -78.916235],
      countryCode: "CA",
    },
    {
      countryCode: "CA",
      name: "Ottawa International Airport",
      city: "Ottawa",
      coordinates: [45.325365, -75.654057],
      urlString: "ottawa-international-airport",
      postalCode: "K1V0R4",
      state: "ON",
      waitTimeDays: 365,
      shortName: "Ottawa Enrollment Center",
      id: "5025",
    },
    {
      waitTimeDays: 365,
      city: "Richmond",
      coordinates: [49.197589, -123.136614],
      id: "5026",
      name: "Vancouver Enrollment Center",
      state: "BC",
      urlString: "vancouver-enrollment-center",
      shortName: "Vancouver Enrollment Center",
      countryCode: "CA",
      postalCode: "V7B1Y9",
    },
    {
      city: "Mississauga",
      postalCode: "L5P1B2",
      coordinates: [43.682567, -79.596794],
      countryCode: "CA",
      urlString: "toronto-enrollment-center",
      name: "Toronto Enrollment Center",
      id: "5027",
      shortName: "Toronto Enrollment Center",
      state: "ON",
      waitTimeDays: 365,
    },
    {
      shortName: "Montreal Enrollment Center",
      city: "Montreal",
      countryCode: "CA",
      waitTimeDays: 365,
      urlString: "montreal-enrollment-center",
      postalCode: "H2Y1H1",
      id: "5028",
      state: "QC",
      coordinates: [45.50825, -73.552295],
      name: "Montreal Enrollment Center",
    },
    {
      waitTimeDays: 365,
      state: "MB",
      coordinates: [49.905925, -97.223405],
      id: "5029",
      shortName: "Winnipeg Enrollment Center",
      urlString: "winnipeg-enrollment-center",
      city: "Winnipeg",
      postalCode: "R3H0E3",
      countryCode: "CA",
      name: "Winnipeg Enrollment Center",
    },
    {
      id: "5030",
      urlString: "calgary-enrollment-center",
      state: "AB",
      postalCode: "T2E6W5",
      shortName: "Calgary Enrollment Center",
      countryCode: "CA",
      waitTimeDays: 365,
      city: "Calgary",
      coordinates: [51.130257, -114.009656],
      name: "Calgary Enrollment Center",
    },
    {
      coordinates: [44.886808, -63.514921],
      waitTimeDays: 365,
      id: "5031",
      shortName: "Halifax Enrollment Center",
      state: "NS",
      city: "Goffs",
      name: "Halifax Enrollment Center",
      urlString: "halifax-enrollment-center",
      countryCode: "CA",
      postalCode: "B2T1K2",
    },
    {
      city: "Edmonton",
      shortName: "Edmonton Enrollment Center",
      coordinates: [53.30963, -113.58503],
      state: "AB",
      waitTimeDays: 365,
      id: "5032",
      countryCode: "CA",
      name: "Edmonton Enrollment Center",
      postalCode: "T9E0V3",
      urlString: "edmonton-enrollment-center",
    },
    {
      urlString: "vancouver-urban-enrollment-center",
      countryCode: "CA",
      state: "BC",
      shortName: "Vancouver Urban Enrollment Center",
      postalCode: "V6A2W5",
      waitTimeDays: 365,
      city: "VANCOUVER",
      coordinates: [49.271194, -123.101309],
      name: "Vancouver Urban Enrollment Center",
      id: "5041",
    },
    {
      postalCode: "58271",
      countryCode: "US",
      state: "ND",
      id: "5100",
      coordinates: [48.912895, -97.289694],
      urlString: "pembina-enrollment-center",
      city: "Pembina",
      waitTimeDays: 365,
      name: "Pembina Enrollment Center",
      shortName: "Pembina Enrollment Center",
    },
    {
      urlString: "houlton-poe-woodstock",
      countryCode: "CA",
      postalCode: "E7M4Z9",
      id: "5101",
      waitTimeDays: 365,
      state: "NB",
      shortName: "Houlton Enrollment Center",
      city: "Belleville",
      name: "Houlton POE/Woodstock",
    },
    {
      shortName: "Sweetgrass NEXUS and FAST",
      waitTimeDays: 365,
      state: "MT",
      name: "Sweetgrass NEXUS and FAST Enrollment Center",
      id: "5120",
      countryCode: "US",
      postalCode: "59484",
      urlString: "sweetgrass-nexus-and-fast-enrollment-center",
      coordinates: [48.967184, -111.658692],
      city: "Sweetgrass",
    },
    {
      shortName: "Lansdowne, ON ",
      city: "Lansdowne",
      waitTimeDays: 365,
      urlString: "lansdowne-on",
      postalCode: "K0E1L0",
      coordinates: [44.397935, -76.036624],
      countryCode: "CA",
      state: "ON",
      id: "5520",
      name: "Lansdowne, ON ",
    },
  ],
  updatedAt: "2022-02-22T01:10:09Z",
};
export default data;
